import axios from 'axios'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api/v1',
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor to attach JWT token
apiClient.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Handle 401 errors - redirect to login
    if (error.response && error.response.status === 401) {
      clearToken()
      window.location.href = '/login'
    }
    
    // Return consistent error structure
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred'
    return Promise.reject({
      message: errorMessage,
      status: error.response?.status,
      data: error.response?.data,
      original: error
    })
  }
)

// Token management helpers
export function setToken(token) {
  if (token) {
    localStorage.setItem('jwt_token', token)
  }
}

export function getToken() {
  return localStorage.getItem('jwt_token')
}

export function clearToken() {
  localStorage.removeItem('jwt_token')
}

export default apiClient
